import React from "react";

const MediumSvg = () => {
	return (
		<svg
			width="20"
			height="12"
			viewBox="0 0 20 12"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<title>Medium</title>
			<path
				d="M11.0346 5.99992C11.0346 8.91408 8.71337 11.2766 5.84998 11.2766C2.98653 11.2766 0.665527 8.91477 0.665527 5.99992C0.665527 3.08501 2.98672 0.723389 5.84998 0.723389C8.71325 0.723389 11.0346 3.0857 11.0346 5.99992ZM16.7222 5.99992C16.7222 8.74325 15.5615 10.967 14.1299 10.967C12.6983 10.967 11.5376 8.7425 11.5376 5.99992C11.5376 3.25728 12.6983 1.03285 14.1299 1.03285C15.5615 1.03285 16.7222 3.25728 16.7222 5.99992ZM19.0485 5.99992C19.0485 8.45779 18.6403 10.4502 18.1368 10.4502C17.6333 10.4502 17.225 8.4571 17.225 5.99992C17.225 3.54275 17.6333 1.54961 18.1369 1.54961C18.6406 1.54961 19.0485 3.54218 19.0485 5.99992Z"
				fill="white"
				className="fill-white dark:fill-darkCardBg"
			/>
		</svg>
	);
};

export default MediumSvg;
